import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, SectionHeader } from "../components/Card";
import { Button } from "../components/Button";
import { Input } from "../components/Input";

export function ForgotPasswordScreen() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch("/api/account/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to send reset email");
      }

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "var(--bg)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 16
    }}>
      <Card style={{ maxWidth: 450, width: "100%", margin: 0 }}>
        <SectionHeader
          emoji="🔒"
          title="Forgot Password"
          subtitle="Enter your email address and we'll send you a reset link."
        />

        {success ? (
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h3 style={{
              fontFamily: "var(--font-display)",
              fontSize: 20,
              fontWeight: 700,
              color: "var(--text)",
              marginBottom: 8
            }}>
              Check Your Email
            </h3>
            <p style={{ fontSize: 14, color: "var(--text-muted)", lineHeight: 1.6, marginBottom: 20 }}>
              If an account with that email exists, a password reset link has been sent.
              Please check your inbox and spam folder.
            </p>
            <Button
              label="Back to Login"
              onClick={() => navigate("/login")}
              icon="←"
              style={{ fontSize: 14 }}
            />
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ marginTop: 20 }}>
            <Input
              label="Email Address"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              disabled={loading}
            />

            {error && (
              <div style={{
                marginTop: 12,
                padding: "12px 16px",
                background: "var(--status-danger-bg)",
                border: "1px solid var(--status-danger-border)",
                borderRadius: 8,
                color: "var(--status-danger)",
                fontSize: 13
              }}>
                {error}
              </div>
            )}

            <div style={{ marginTop: 20, display: "flex", gap: 12, flexDirection: "column" }}>
              <Button
                type="submit"
                label={loading ? "Sending..." : "Send Reset Link"}
                loading={loading}
                icon="📧"
              />

              <button
                type="button"
                onClick={() => navigate("/login")}
                disabled={loading}
                style={{
                  padding: "12px 20px",
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: 14,
                  background: "transparent",
                  color: "var(--text-muted)",
                  border: "1px solid var(--border)",
                  cursor: loading ? "not-allowed" : "pointer",
                  transition: "all 0.15s ease"
                }}
              >
                Back to Login
              </button>
            </div>
          </form>
        )}
      </Card>
    </div>
  );
}
